"use client";

import { Trans, t } from "@lingui/macro";
import React from "react";
import styled from "styled-components";
import IconBusiness from "../_assets/investor-type-tabs/business.svg";
import IconCity from "../_assets/investor-type-tabs/location_city.svg";
import IconPerson from "../_assets/investor-type-tabs/person.svg";
import DesktopInvestorTypeTabs from "./DesktopInvestorTypeTabs";
import MobileInvestorTypeTabs from "./MobileInvestorTypeTabs";

const Title = styled.h2`
  font-family: "PP Right Didone";
  font-size: 45px;
  font-style: italic;
  font-weight: 700;
  line-height: normal;
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: 28px;
    margin-bottom: ${({ theme }) => theme.spacing(6)};
  }
`;

const DesktopOnly = styled.div`
  display: block;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: none;
  }
`;

const MobileOnly = styled.div`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: block;
  }
`;

const InvestorTypeTabs = () => {
  const TABS = [
    {
      key: "fund",
      label: t`An investment fund`,
      icon: IconCity,
      text: t`You are an investment company specializing in hotel real estate, looking to develop a portfolio of assets that meet either Value-Add strategies, with strong value creation potential, or Core strategies, with resilient and heritage assets ensuring long-term stability. You are also interested in innovative models that combine performance, differentiated experience, and ESG standards.`,
    },
    {
      key: "family",
      label: t`A family office`,
      icon: IconBusiness,
      text: t`You are a wealth management organization looking to diversify your investments with hotel assets with a strong identity. You favor tailor-made operations that offer optimized management, long-term valuation, and alignment with your values. You are looking for a flexible and sustainable approach, capable of integrating ESG criteria, a local approach, and governance tailored to your wealth management vision.`,
    },
    {
      key: "private",
      label: t`Private owners`,
      icon: IconPerson,
      text: t`Are you a private investor or a family with a property and want to operate it under a successful hotel model? We offer you a turnkey solution, guaranteeing optimized income, asset value, and minimal involvement in management. Attentive to local roots, customer experience, and a positive impact on the region, you benefit from controlled and profitable operations, without operational constraints.`,
    },
  ];

  return (
    <div style={{ marginBottom: "120px" }}>
      <Title>
        <Trans>You are ?</Trans>
      </Title>

      <DesktopOnly>
        <DesktopInvestorTypeTabs tabs={TABS} />
      </DesktopOnly>

      <MobileOnly>
        <MobileInvestorTypeTabs tabs={TABS} />
      </MobileOnly>
    </div>
  );
};

export default InvestorTypeTabs;
